import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAuth } from 'contexts/AuthContext';

export interface PauseSubscriptionParams {
  workspaceId: string;
  workspaceSlug: string;
}

export const usePauseSubscription = () => {
  const { authApi } = useAuth();
  const queryClient = useQueryClient();

  return useMutation<void, Error, PauseSubscriptionParams>({
    mutationFn: async ({ workspaceId }) => {
      await authApi.post(`/workspace/${workspaceId}/subscription/pause`);
    },
    onSuccess: (_, variables) => {
      // Invalidate subscription queries for this workspace
      queryClient.invalidateQueries({ queryKey: ['subscription', variables.workspaceSlug] });
    },
    onError: (error: Error) => {
      console.error('Error pausing subscription:', error);
    }
  });
};
